import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

const DashboardFilterModal = ({ setSalesOrderId }) => {
    const { handleSubmit, control } = useForm();
    const { useFetch: fetchGenericData } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data: genericData, isLoading: IsGenericLoading } = fetchGenericData(
        {
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        }
    );
    const onSubmit = (data) => {
        console.log(data);
        if (data.so.value === "all") {
            setSalesOrderId(null);
        } else {
            setSalesOrderId(data.so.value);
        }
    };

    // console.log([
    //     {
    //         value: null,
    //         label: "All",
    //     },
    //     ...genericData?.sales_order?.map((so) => ({
    //         value: so?.id,
    //         label: so?.so_number,
    //     })),
    // ]);
    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id="dashboard-filter"
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Filter</h5>
                        <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <em className="icon ni ni-cross" />
                        </button>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label htmlFor={"so"} className="mb-1">
                                            Select Sales Order
                                        </label>
                                        <Controller
                                            name={"so"}
                                            control={control}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={
                                                        genericData
                                                            ? [
                                                                  {
                                                                      value: "all",
                                                                      label: "All",
                                                                  },
                                                                  ...genericData?.sales_order?.map(
                                                                      (so) => ({
                                                                          value: so?.id,
                                                                          label: so?.so_number,
                                                                      })
                                                                  ),
                                                              ]
                                                            : []
                                                    }
                                                    isLoading={IsGenericLoading}
                                                    placeholder={`Select a sales order`}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer bg-light">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DashboardFilterModal;
